<template>
  <v-list-item :href="item.link" target="_blank">
    <v-list-item-content :style="props.style">
      <v-list-item-title>{{ item.name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'FileMobileMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
